import React from "react";
import { useGlobalNetworkState } from "../contexts/GlobalNetworkStateContext";
import styles from "../styles/GlobalNetworkStateDialogStyles"; // Importing the styles
import "../styles/ProgressBarStyles.css"; // Importing the new progress bar styles

const GlobalNetworkStateDialog = () => {
  const { loading } = useGlobalNetworkState();

  if (!loading) return null;

  return (
    <div style={styles.loadingDialog}>
      <div className="progress-bar"></div>
      <p>Loading...</p>
    </div>
  );
};

export default GlobalNetworkStateDialog;